import React from 'react';
import { Container, Typography, Box, useTheme } from '@mui/material';
import { ContentUseCase } from '../../corelogic/usecases/ContentUseCase';
import { useLanguage } from '../../shared/contexts/LanguageContext';
import { SEO } from './SEO';

const contentUseCase = new ContentUseCase();

export const ImpressumPage: React.FC = () => {
  const theme = useTheme();
  const { language } = useLanguage();
  const { impressum } = contentUseCase.getLegalContent(language);

  return (
    <Container maxWidth="md" sx={{ py: theme.spacing(8) }}>
      <SEO page="impressum" />
      <Typography variant="h2" component="h1" gutterBottom align="center" color="primary" sx={{ mb: theme.spacing(6) }}>
        {impressum.title}
      </Typography>
        {/* Contact Information */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {impressum.contact.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.contact.initiative}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.contact.description}
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 600 }} color="text.primary">{impressum.contact.name}</Typography>
          <Typography variant="body1" color="text.primary">{impressum.contact.address}</Typography>
          <Typography variant="body1" color="text.primary">{impressum.contact.city}</Typography>
          <Typography variant="body1" color="text.primary">{impressum.contact.country}</Typography>
          <Typography variant="body1" sx={{ mt: 1 }} color="text.primary">{impressum.contact.email}</Typography>
          <Typography variant="body1" sx={{ mt: 1 }} color="text.primary">{impressum.contact.management}</Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {impressum.contact.registerTitle}
          </Typography>
          <Typography variant="body1" color="text.primary">{impressum.contact.registerInfo}</Typography>
          <Typography variant="body1" color="text.primary">{impressum.contact.registerCourt}</Typography>
          <Typography variant="body1" color="text.primary">{impressum.contact.registerNumber}</Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {impressum.contact.ustIdTitle}
          </Typography>
          <Typography variant="body1" color="text.primary">{impressum.contact.ustId}</Typography>
        </Box>

        {/* Purpose */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {impressum.purpose.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.purpose.description}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.purpose.goal}
          </Typography>
        </Box>

        {/* Disclaimer */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {impressum.disclaimer.title}
          </Typography>
          
          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {impressum.disclaimer.content.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.disclaimer.content.text}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {impressum.disclaimer.external.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.disclaimer.external.text}
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }} color="text.primary">
            {impressum.disclaimer.donations.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.disclaimer.donations.text}
          </Typography>
        </Box>

        {/* Copyright */}
        <Box sx={{ mb: theme.spacing(6) }}>
          <Typography variant="h4" gutterBottom color="primary">
            {impressum.copyright.title}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.copyright.description}
          </Typography>
          <Typography variant="body1" paragraph color="text.primary">
            {impressum.copyright.images}
          </Typography>
        </Box>
    </Container>
  );
};

